import Icon from '@/root/ui/shared/Icon'
import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'

export const InfoIcon2: FC<IconProps> = ({ width = 20, height = 36, className, ...rest }) => (
  <Icon type="Info1" width={width} height={height} alt="Info" className={className} {...rest} />
)
